// $('body').on('click', '.footer-nav-tab', function (e) {
//
//   $('footer .footer-nav-tab').removeClass('is-active')
//   $(this).addClass('is-active')
//
// })


$('.js-footer-accordion-title').click(function (){
  let accordion = $(this).closest('.js-accordion')
  let content = accordion.find('.js-accordion-content')

  $('footer .js-accordion-content').each(function (i, el){
    if (el !== content[0]){
      $(el).slideUp()
      $(el).closest('.js-accordion').removeClass('is-active')
    }
  })

  //content.slideToggle()
  if (content.css('display') === 'block'){
    accordion.removeClass('is-active')
    content.slideUp(400)
  } else {
    accordion.addClass('is-active')
    content.slideDown(400)
  }
})
